// fpti page/link names
export const BUTTON_DELETED = 'button_deleted';
export const BUTTON_MANAGER = 'button_manager';
export const BACK_TO_MANAGE_LINK = 'back_to_manage_link';
export const BUTTON_OVERVIEW = 'button_overview';
export const CLOSE = 'close';
export const KEEP_THIS_BUTTON_LINK = 'keep_this_button_link';
export const GO_BACK_BUTTON = 'go_back_button';
export const CLOSE_PREVIEW = 'close_preview';
export const COPY_CODE_LINK = 'copy_code_link';
export const COPY_LINK = 'copy_link';
export const DELETE_DONATE_LINK = 'delete_donate_link';
export const DELETE_DONATE_LINK_ALERT = 'delete_donate_link_alert';
export const DELETE_DONATE_LINK_ERROR = 'delete_donate_link_error';
export const DOWNLOAD_QR_LINK = 'download_qr_link';
export const DUPLICATE_DONATE_LINK = 'duplicate_donate_link';
export const EDIT_DONATE_LINK = 'edit_donate_link';
export const ENTRY_POINT_HAWK = 'hawk_homepage';
export const ENTRY_POINT_DIRECT = 'direct';
export const LOGIN_LINK = 'login_link';
export const MANAGE_BUTTON_LINK = 'manage_button_link';
export const MANAGE_PAGE_LOGIN = 'manage_page_login';
export const MANAGE_VOUCHER_LINK = 'manage_voucher_link';
export const OPEN_PREVIEW_LINK = 'open_preview_link';
export const OVERVIEW_PAGE_LOGIN_TILE = 'overview_page_login_tile';
export const ADVANCED_DONATE_BUTTON_EXPERIENCE_LINK =
  'advanced_donate_button_experience_link';
export const PARTNER_DONATE_LINK = 'partner_donate_link';
export const QUICK_DONATE_LINK = 'quick_donate_link';
export const CUSTOM_DONATE_LINK = 'custom_donate_link';
// error code
export const UNAUTHORIZED = 'UNAUTHORIZED';
export const INVALID_BUTTON = 'INVALID_HOSTED_BUTTON_ID';
export const FUND_RAISER_NOT_FOUND = 'FUND_RAISER_NOT_FOUND';
export const METHOD_NOT_SUPPORTED = 'METHOD_NOT_SUPPORTED';
export const DRAFT_ERROR = 'DRAFT_ERROR';

export const AMOUNT_OPTIONS = {
  AMOUNT_TYPE_FIXED: 'fixed',
  AMOUNT_TYPE_VARIABLE: 'variable',
  AMOUNT_TYPE_PRESET: 'merchant_recommended',
};

export const ORG_UPDATES_SHEET_TYPES = {
  POST_UPDATE_FORM: 'showPostUpdateForm',
  EDIT_UPDATE_FORM: 'showEditUpdateForm',
  UPDATES_LIST_VIEW: 'showUpdatesList',
  UPDATE_DETAIL_VIEW: 'showUpdateDetailView',
  UPDATE_DELETE_CONFIRMATION: 'openDeleteConfirmation',
  UPDATE_SHARE_VIEW: 'showShareUpdate',
};

export const ORG_UPDATES_PAGE_VARIANTS = {
  POST_NEW_UPDATE: 'post_new_update',
  EDIT_EXISTING_UPDATE: 'edit_existing_update',
};

export const STATUS = {
  ACTIVE: 'ACTIVE',
  ENDED: 'ENDED',
  CLOSED: 'INACTIVE',
  GOAL_REACHED: 'GOAL_REACHED',
  DRAFT: 'DRAFT',
};

export const STATUS_PRIORITY = {
  DRAFT: 5,
  ACTIVE: 4,
  INACTIVE: 3,
  ENDED: 2,
  GOAL_REACHED: 1,
};
